import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Form, FormLayout, Button, Select, Checkbox } from '@shopify/polaris';

import { BasicTextField } from '@presentational';
import { fullName } from '@utils';
import { tAttribute } from '@utils';

const propTypes = {
  users: PropTypes.array.isRequired,
  locations: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};

class SellerFormProfile extends Component{

  render() {
    console.log("SellerFormProfile", this.props);
    let { handleSubmit, isNested } = this.props;
    if ( isNested ) {
      return (
          <FormLayout>
            <h2 className="Polaris-DisplayText Polaris-DisplayText--sizeLarge">Seller</h2>
            <hr />
            {this.formContent()}
          </FormLayout>
      )
    }
    else{
      return (
          <Form onSubmit={handleSubmit}>
            <FormLayout>
              <hr />
              {this.formContent()}
              <Button submit>Submit</Button>
            </FormLayout>
          </Form>
      );
    }
  }

  formContent = () => {
    let { users, locations, handleChange, handleSubmit, values, errors, isNested } = this.props;
    let sharedFieldProps = {
      handleChange,
      values,
      errors
    }

    return (
        <div>
          <BasicTextField
            name="vendor"
            label={ tAttribute("seller", "vendor")}
            disabled={true}
            {...sharedFieldProps}
          />

          <BasicTextField
            name="default_location_id"
            label={ tAttribute("seller", "default_location_id") }
            disabled={true}
            value={ locations }
            {...sharedFieldProps}
          />

          <BasicTextField
            name="legal_id"
            label={ tAttribute("seller", "legal_id") }
            {...sharedFieldProps}
          />

          <BasicTextField
            name="address"
            label={ tAttribute("seller", "address") }
            {...sharedFieldProps}
          />

          <BasicTextField
            name="phone_number"
            label={tAttribute("seller", "phone_number")}
            {...sharedFieldProps}
          />

          <BasicTextField
            name="bank_account_number"
            label={tAttribute("seller", "bank_account_number")}
            {...sharedFieldProps}
          />

          <Checkbox 
            label={ tAttribute("seller", "email_report") }
            checked={ values.email_report }
            onChange={ (value) => handleChange(value, 'email_report') }
          />
        </div>
    );
  }

}


SellerFormProfile.propTypes = propTypes;


export default SellerFormProfile;